angular.module('zc.zenclerkS')

  .component('zcsDashboardWidgetCreateFirstCampaign', {
    templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-create-first-campaign.html',
    require: {
      dashboard: '^zcsDashboardMain'
    },
    controller: zcsDashboardWidgetCreateFirstCampaignController
  });

zcsDashboardWidgetCreateFirstCampaignController.$inject = ['ZcsOemService'];
function zcsDashboardWidgetCreateFirstCampaignController(ZcsOemService) {
  const vm = this;

  vm.$onInit = () => {
    vm.ZcsOemService = ZcsOemService;
    vm.project = vm.dashboard.project;
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/widgets/dashboard-widget-create-first-campaign.component.js